module.exports = __webpack_public_path__ + "assets/img/ico_xbox.08914c91.svg";